import React, { PureComponent } from 'react';
import { renderToString } from 'react-dom/server';
import PropTypes from 'prop-types';

import { AngleDownLightIcon, AngleUpLightIcon } from '../../shared/icons/icons';

import { ChildrenProp } from '../../shared/utils/prop-types/prop-types';

import './read-more.scss';

class ReadMore extends PureComponent {
  static propTypes = {
    children: ChildrenProp,
    contentClassName: PropTypes.string,
    defaultMaxHeight: PropTypes.number,
    onClick: PropTypes.func
  };

  static defaultProps = {
    contentClassName: '',
    defaultMaxHeight: 250
  };

  state = {
    contentMaxHeight: null,
    defaultContentMaxHeight: null,
    readingMore: false,
    showReadMore: false
  };

  componentDidMount() {
    const { contentClassName } = this.props;
    const defaultContentMaxHeight = this.getDefaultMaxHeight();

    if (contentClassName) {
      this.setState(
        {
          contentMaxHeight: defaultContentMaxHeight,
          defaultContentMaxHeight
        },
        () => {
          this.shouldShowReadMore();
        }
      );
    } else {
      this.shouldShowReadMore();
    }

    window.addEventListener('resize', this.shouldShowReadMore);
  }

  componentDidUpdate(prevProps) {
    const { children } = this.props;
    let serializedPrevChildren = this.serializeChildren(prevProps.children);
    let serializedChildren = this.serializeChildren(children);

    if (serializedPrevChildren !== serializedChildren) {
      this.shouldShowReadMore();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.shouldShowReadMore);
  }

  getDefaultMaxHeight = () => {
    let defaultMaxHeight = this.props.defaultMaxHeight;

    if (this.props.contentClassName) {
      const computedStyles = getComputedStyle(this.readMore);
      defaultMaxHeight = computedStyles.maxHeight;
    }

    return defaultMaxHeight;
  };

  serializeChildren = (children = '') => {
    let serializedChildren = '';

    if (Array.isArray(children)) {
      serializedChildren = children.reduce(
        (accum, child) => accum + this.serializeChildren(child),
        ''
      );
    } else if (typeof children === 'object') {
      serializedChildren = renderToString(children);
    } else {
      serializedChildren = JSON.stringify(children);
    }

    return serializedChildren;
  };

  toggleReadMore = () => {
    const { readingMore, defaultContentMaxHeight } = this.state;
    const { onClick } = this.props;

    this.setState(
      {
        contentMaxHeight: readingMore ? defaultContentMaxHeight : 20000,
        readingMore: !readingMore
      },
      () => {
        if (onClick) {
          onClick({
            contentHeight: this.readMore.clientHeight,
            defaultContentMaxHeight,
            readingMore: !readingMore
          });
        }
      }
    );
  };

  shouldShowReadMore = () => {
    const { readingMore } = this.state;
    const containerHeight = this.readMore.clientHeight;
    const contentHeight = this.readMore.children[0].clientHeight;

    if (!readingMore) {
      if (containerHeight < contentHeight) {
        this.setState({ showReadMore: true });
      } else {
        this.setState({ showReadMore: false });
      }
    }
  };

  render() {
    const { children, contentClassName } = this.props;
    const { contentMaxHeight, readingMore, showReadMore } = this.state;

    return (
      <div className="container">
        <div
          className={contentClassName}
          ref={r => (this.readMore = r)}
          style={{ maxHeight: contentMaxHeight }}
          styleName="content"
        >
          <div className="content">{children}</div>
        </div>
        {showReadMore && (
          <button
            onClick={this.toggleReadMore}
            styleName="toggle"
            type="button"
          >
            read {readingMore ? 'less' : 'more'}
            {readingMore ? (
              <AngleUpLightIcon styleName="toggle-icon" />
            ) : (
              <AngleDownLightIcon styleName="toggle-icon" />
            )}
          </button>
        )}
      </div>
    );
  }
}

export default ReadMore;
